<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>施工管理</el-breadcrumb-item>
      <el-breadcrumb-item>商城产品明细</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="10">
          <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
            style="width:300px " @clear="getorderList" @change="getorderList">
            <el-button slot="append" icon="el-icon-search" @click="getorderList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="get_order_add" style="font-size: 15px;" v-if="false">添加订单</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="orderList" style="width: 100%" border stripe>
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
            <el-table-column prop="guest_bianhao" label="客户编号"></el-table-column>
            <el-table-column prop="guest_mob" label="客户手机"></el-table-column>
            <el-table-column prop="pro_name" label="名称" width="200"></el-table-column>
            <el-table-column prop="pro_count" label="数量"></el-table-column>
            <el-table-column prop="pro_price" label="数量"></el-table-column>
            <el-table-column prop="add_time" label="订单时间"></el-table-column>
            <el-table-column prop="pay_flag" label="支付状态" width="130">
              <template v-slot="scope"> <span> {{ scope.row.pay_flag === 1 ? '已支付' : '未支付' }}</span></template>
            </el-table-column>
            <el-table-column  label="核销状态" width="130">
              <template v-slot="scope"> <span> {{ scope.row.hexiao_flag === 1 ? '已核销' : '未核销' }}</span></template>
            </el-table-column>
            <el-table-column label="操作" v-if="true">
              <template v-slot="scope">
                 
                <el-tooltip class="item" effect="dark" content="确认核销" placement="top" :enterable="false" >
                                    <el-button type="primary" icon="el-icon-s-goods" circle size="mini"
                                        @click="sjForm(scope.row.uid,scope.row.kucun_uid,scope.row.pro_count  ,scope.row.hexiao_flag)"></el-button>
                                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>
      <el-dialog :title="kaidan_title"  :visible.sync="addDialogVisible" width="95%"   @close="addDoalogClosed" >
        <kaidanAdd ref="kaidanAddRef" @orderOver="orderOver" @kaidan_addClose="kaidan_addClose" :key="datekey" >   </kaidanAdd>
      </el-dialog>
      <el-dialog :title="kaidan_title"  :visible.sync="infoDialogVisible" width="95%"   >
        <kaidanFunc ref="kaidanFuncRef" :orderInfo="orderInfo" show_type="cheliang_info" :diaoyongType="1" :key="datekey" > </kaidanFunc>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from './config/validator';
import kaidanAdd from './module/kaidan_add.vue'
import kaidanFunc from './module/func.vue'
export default {
  components: {
    kaidanAdd: kaidanAdd,
    kaidanFunc: kaidanFunc
  },
  data() {
    return {
      orderInfo: {},
      kaidan_title: '运营开单',
      datekey: Date.now(),
      waiguan_options: [
        {
          value: '完好无损',
          label: '完好无损'
        },
        {
          value: '有瑕疵',
          label: '有瑕疵'
        },
        {
          value: '很差',
          label: '很差'
        }
      ],
      color_options: [
        {
          value: '白色',
          label: '白色'
        },
        {
          value: '黑色',
          label: '黑色'
        },
        {
          value: '红色',
          label: '红色'
        },
        {
          value: '黄色',
          label: '黄色'
        },
        {
          value: '绿色',
          label: '绿色'
        }
      ],
      orderLy_options: [
        {
          value: 1,
          label: '订单介绍'
        },
        {
          value: 2,
          label: '回访订单'
        },
        {
          value: 3,
          label: '上门订单'
        }
      ],
      order_options: [
        {
          value: 1,
          label: '初级订单'
        },
        {
          value: 2,
          label: '中级订单'
        },
        {
          value: 3,
          label: '高级订单'
        }
      ],
      guestLy_options: [
      {
          value: 1,
          label: '抖音'
        },
        {
          value: 2,
          label: '美团'
        },
        {
          value: 3,
          label: '自然到店'
        },
        {
          value: 4,
          label: '邀约'
        },
        {
          value: 5,
          label: '转介绍'
        },
        {
          value: 6,
          label: '领券'
        },
        {
          value: 7,
          label: '其他'
        }
      ],
      guest_options: [
        {
          value: 1,
          label: '初级客户'
        },
        {
          value: 2,
          label: '中级客户'
        },
        {
          value: 3,
          label: '高级客户'
        }
      ],
      // 获取用户列表参数
      queryInfo: {
        C_type: 'get_list',
        C_table_name: 'order_mingxi_list_shangcheng',
        query: '',
        pageNum: 1,
        pageSize: 10,
        qiye_uid: window.sessionStorage.getItem('qiye_uid')
      },
     
      orderList: [],
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      infoDialogVisible: false
    };
  },
  created() {
    this.getorderList();
  },
  methods: {
    async sjForm(mingxiUid, kucunUid, proCount, hexiaoFlag) {
            const comfirmResult = await this.$confirm(
                '确定核销吗?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            console.log(comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消');
            if (hexiaoFlag === 1) hexiaoFlag = 0 
            else hexiaoFlag = 1
            const { data: res } = await this.$http.post('api', {
                C_type: 'order_mingxi_hexiao',
                mingxi_uid: mingxiUid,
                kucun_uid: kucunUid,
                pro_count: proCount,
                hexiao_flag: hexiaoFlag
            });
            if (JSON.parse(res.data)[0].status !== 200) {
                this.$message.error('设置失败');
                return;
            }
            this.$message.success('设置成功');
            this.getorderList();
        },

    async  order_show(uid) {
      var queryInfoOrder = {
        C_type: 'get_info',
        C_table_name: 'order_info',
        uid: uid
      }
      const { data: res } = await this.$http.get('get_api', {
        params: queryInfoOrder
      }) 
      this.orderInfo = JSON.parse(res.data)[0].data[0]
       console.log('orderInfo', this.orderInfo)
      this.datekey = Date.now()
      this.infoDialogVisible = true 
    },
    kaidan_addClose(data) {
       this.addDialogVisible = false
       this.getorderList();
    },
    orderOver(data) {
      console.log(808)
      this.addDialogVisible = false
      this.getorderList();
    },
    get_order_add() {
      this.addDialogVisible = true
      this.datekey = Date.now()
    },
    async getorderList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
      // console.log(JSON.parse(res.data))
      this.orderList = JSON.parse(res.data)[0].dataList;

      if (!this.orderList) return;
      this.orderList.forEach(function (item) {
        item.yong_flag = item.yong_flag === 1;
      });

      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total)
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getorderList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getorderList();
    },
    addDoalogClosed() {
      this.$refs.kaidanAddRef.input_init();
    },
    huifangDoalogClosed() {
      this.$refs.huifangFormRef.resetFields();
    },
    showHuifangDialog(uid) {
      this.huifangDialogVisible = true;
      this.orderInfo(uid);
    },
    editDoalogClosed() {
      this.$refs.editFormRef.resetFields();
    },
    // 删除一条记录
    async deleteForm(orderUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确定删除该条记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      // console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'order_del',
        C_data1: orderUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败');
        return;
      }
      this.$message.success('删除成功');
      this.getorderList();
    }
  }
};
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
  background-color: #f2f6fc;
}

.el_row_two {
  margin-top: 30px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.left01{
  position: absolute;
  left: 0;
  width: 250px;
  min-width: 250rpx
}
.kaidan {
  position: absolute;
  left: 200px;
  display: flex;
  flex-direction: column;
}

.card_style {
  height: 100%;
}

.kaidan_title {
  background-color: #eee;
  width: 100%;
  height: 40px;
  font-size: 30px;
  color: black;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  padding-top: 8px;
}

.kaidan_body {
  display: flex;
  flex-direction: row;
  position: relative;
}
</style>
